module.exports = __webpack_public_path__ + "img/data.d7cfbfc4.png";